import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class BrowserCompatibilityService {
  constructor() {}

  isBrowserCompatible() {
    return !this.isIE();
  }

  isIE() {
    const ieTest = this.detectIE();
    return ieTest;
  }


  detectIE() {
    const ua = window.navigator.userAgent;

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      return true;
    }

    // IE11
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      return true;
    }

    // other browser
    return false;
  }
}
